import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    SendSharedInboxVerificationEmail as SendSharedInboxVerificationEmailMutation,
    SendSharedInboxVerificationEmailVariables as SendSharedInboxVerificationEmailMutationVariables,
} from 'nutshell-graphql-types';

import SEND_SHARED_INBOX_VERIFICATION_EMAIL from '../mutations/send-shared-inbox-verification-email.graphql';

export const useSendSharedInboxVerificationEmail = (): {
    sendVerificationEmail: (emailAddress: string) => Promise<unknown>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [sendVerificationEmail, {loading, error}] = useMutation<
        SendSharedInboxVerificationEmailMutation,
        SendSharedInboxVerificationEmailMutationVariables
    >(SEND_SHARED_INBOX_VERIFICATION_EMAIL);

    return {
        sendVerificationEmail: (emailAddress: string) => {
            return sendVerificationEmail({
                variables: {input: {emailAddress}},
            });
        },
        isLoading: loading,
        // @ts-expect-error
        error: error && safelyGetGraphQLErrorMessage(error),
    };
};
